import Vue from 'vue'
import Vuex from 'vuex'
import customers from './modules/customer'
import databases from './modules/databases'
import devices from './modules/devices'
import externalConnections from './modules/external-connections'
import heatmap from './modules/heatmap'
import home from './modules/home'
import impersonate from './modules/impersonate'
import mail from './modules/mail'
import notifications from './modules/notifications'
import parser from './modules/parser'
import query from './modules/query'
import renewals from './modules/renewals'
import spotlightSearch from './modules/spotlightSearch'
import stock from './modules/stock'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    customers,
    databases,
    devices,
    externalConnections,
    mail,
    notifications,
    home,
    heatmap,
    impersonate,
    spotlightSearch,
    parser,
    query,
    renewals,
    stock,
  }
})


